import {
  List,
  Datagrid,
  TextField,
  EditButton,
  DeleteButton,
  FunctionField,
} from 'react-admin';

export const BrandList = () => (
  <List>
    <Datagrid>
      <FunctionField
        label="Logo"
        render={(record: any) => {
          const logo = record.logo;
          if (!logo) return null;
          
          // Use thumbnail if available, otherwise fallback to original
          const imageUrl = logo.thumbnails?.find((t: any) => t.type === 'W550')?.url || logo.url;
          
          return (
            <img 
              src={imageUrl} 
              alt={record.name} 
              style={{ maxWidth: 50, maxHeight: 50, objectFit: 'cover' }} 
            />
          );
        }}
      />
      <TextField source="name" />
      <TextField source="description" />
      <TextField source="slug" />
      <EditButton />
      <DeleteButton mutationMode="pessimistic" />
    </Datagrid>
  </List>
);
